import { getQueryString, _browserLanguage } from './helper'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
// eslint-disable-next-line no-unused-vars
import enUS from 'ant-design-vue/lib/locale-provider/en_US'

let cupI18n = {}, 
antLang = {
  'zh-CN': zhCN,
  'en-GB': enUS
},
eventData = {}

const browerLang = _browserLanguage(true) ? 'zh-CN' : 'en-GB'
// 监听语言切换
const changeMessage = event => {
  if (event.data.type === 'language') {
    setI18n(event.data.value.lang)
    eventData = event.data.value
  }
}
/**
 * 设置语言
 * @param {*} lang 
 */
/**
 * 设置语言
 * @param {*} lang 
 */
export const setI18n = lang => {
  localStorage.setItem('lang', lang)
  const global = cupI18n.global || cupI18n
  global.locale = lang

}
const getLang = () => {
  const lang = getQueryString('lang') || getQueryString('language')  ||   localStorage.getItem('lang') ||'en-GB'
  if(lang && lang.toLowerCase() === 'zh-cn') {
    return 'zh-CN'
  } 
  return 'en-GB'
}

const localOption =  {
  locale: getLang(), //默认显示的语言
  messages: {},
  legacy: false
}

// 定义 install 方法，接收 Vue 作为参数。如果使用 use 注册插件，则所有的组件都将被注册
const install = function (app, option) {
  // 判断是否安装
  if (install.installed) return
  // 拉取数据
  useI18nData(option )

  const VueI18n = require('vue-i18n')
  // vue3
  if (VueI18n.createI18n) {
    const { createI18n } = VueI18n
    cupI18n = createI18n(localOption)
    app.use(cupI18n)
    app.config.globalProperties.i18n = cupI18n
  } else {
    const vueI18n = VueI18n.default || VueI18n
    app.use(vueI18n)
    cupI18n = new vueI18n(localOption)
    cupI18n['global'] = cupI18n
    app.prototype.i18n = cupI18n
  }

  watchI18n()
  

}
/**
 * 拉取词条
 * @param {*} systemId  系统id
 * @param {*} env  环境
 * @returns 
 */
 const useI18nData = (option ={}) => {
   const systemId = eventData.systemId || option.systemId || getQueryString('systemId')
   const nodeENV = eventData.env || option.env  || getQueryString('env')
 
  const config = {
    env: {
      development: 'https://portal-admin-develop.kapeixi.cn',
      release: 'https://portal-admin-release.kapeixi.cn',
      preview: 'https://portal-admin-pre.kapeixi.cn',
      production: 'https://portal-admin.cupshe.com',
      aws: 'https://aws-portal-admin.kapeixi.cn',
    },
    url: `/portal/language/key/map`
  }
  const params = systemId  ? `?systemId=${systemId}` : ''
  const domain = option.domain || config.env[nodeENV || 'production']
  const url = `${domain}${config.url}${params}`
  fetch(url).then((res) => {
    return res.json()
  }).then((res) => {
    if (res.data) {
      mergeLocalMessage(res.data)
    }
  })

}
/**
 * 词条合并
 * @param {*} dictionary 
 */
const mergeLocalMessage =(dictionary) => {
  const global = cupI18n.global || cupI18n
  Object.keys(dictionary).forEach((key)=>{
    const lang = {
      ...dictionary[key],
      ...antLang[key]
    }
    global.mergeLocaleMessage(key,lang)
  })
  setI18n(global.locale)
}

/**
 * 导出useI18n
 * @returns 
 */
export const useI18n = require('vue-i18n').useI18n
/**
 * 监听父iframe切换多语言
 */
 export const watchI18n = () => {
   setI18n(getLang() || browerLang)
  if (typeof window.addEventListener !== 'undefined') {
    window.addEventListener('message', changeMessage, false)
  } else if (typeof window.attachEvent !== 'undefined') {
    window.attachEvent('onmessage', changeMessage)
  }
}
export default {
  install
}